<template>
    <div>
        <Row type="flex" justify="end" style="margin-bottom: 40px;">
        <i-col>
            <i-select v-if="tipo=='bug'" filterable clearable v-model="modulo" placeholder="Modulo" class="w-64 ml-2">
                <Option v-for="item in modulos" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <i-select filterable clearable v-model="funcao" v-if="modulo!=null && tipo=='bug'" placeholder="Função" class="w-64 ml-2">
                <Option v-for="item in funcoes" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <i-select filterable clearable v-model="funcionalidade" v-if="funcao!=null && modulo!=null && tipo=='bug'" placeholder="Funcionalidade" class="w-64 ml-2">
                <Option v-for="item in funcionalidades" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <InputNumber @input="carregarDados" :active-change="false" :min="1" v-model="periodo" style="margin-left:7px;"></InputNumber>
            <i-switch @on-change="carregarDados" false-value="mensal" size="large"
                        true-value="semanal" v-model="formato">
                <span slot="open">SEM</span>
                <span slot="close">MEN</span>
            </i-switch>
            <i-switch size="large" v-model="mostrar_totalizadores" @on-change="carregarDados">
                <span slot="open">CT</span>
                <span slot="close">ST</span>
            </i-switch>
        </i-col>
    </Row>
        <BarChart v-if="mostrar_grafico"
                :options="dados_grafico"
                @click="getDetails"
        />
        <Spin size="large" fix v-if="carregar"></Spin>
        <TicketsTable :csv="csv" :analistas="analistas" :loading="carregar_tabela" :relatores="tickets_pessoas"
                      :tickets="tickets" exibir-andamento v-if="mostrar_tabela"></TicketsTable>
    </div>
</template>

<script>
    import {toQueryString} from "../../../helpers/utils.js"
    const {moment} = require("../../../helpers/utils.js")
    import _ from 'lodash'
    export default {
        components: {
            BarChart: () => import("../../../components/charts/BarChart.vue"),
            TicketsTable: () => import("./tickets-table.vue")
        },
        props: {
            download: Boolean,
            refresh: Boolean,
            close: Boolean,
            tipo: String
        },
        data() {
            return {
                modulo:null,
                modulos:[],
                funcao:null,
                funcoes:[],
                funcionalidade:null,
                funcionalidades:[],
                formato: 'semanal',
                periodo: 6,
                filtro:'',
                mostrar_totalizadores: true,
                mostrar_tabela: false,
                carregar_tabela: false,
                tickets: [],
                dados_grafico: {},
                mostrar_grafico: true,
                dados:[],
                dados_periodo:[],
                legenda:null,
                csv:null,
            }
        },
        computed: {
            tickets_pessoas() {
                let pesssoas = this.$store.getters['usuarios']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }));
                return _.orderBy(pesssoas, ['label'],['asc'])
            },
            analistas() {
                let analistas = this.$store.getters['analistas']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }));
                return _.orderBy(analistas, ['label'],['asc'])
            }
        },
        methods: {
            async carregarDados(filtro='') {
                this.carregar = true
                const URI = `ticket/estatisticas`
                this.filtro = filtro
                const {data} = await this.$axios.get(URI,{
                    params: {
                        formato:this.formato, 
                        periodo:this.periodo,
                        tipo:this.tipo,
                        filtro:filtro
                    }
                })
                this.dados = this.getChartData([...data])
                this.dados_periodo = [...data].reverse().filter(item => item.periodo).map(item => item.periodo)
                this.legenda = this.caregarLegenda(data.length -1)
                this.carregar = false
            },
            getDetails(params) {
                this.mostrar_tabela = false;
                if (params.seriesType === "line" || params.selected) {
                    this.tickets = [];
                    return;
                }
                const tipo = this.tipo
                const categoria = params.seriesName
                const filtro = this.filtro
                const periodo = this.dados_periodo[params.dataIndex]
                const URI = `ticket/estatisticas/detalhe`;
                this.carregar_tabela = true;
                this.$axios.get(URI,{
                    params: {
                        tipo:tipo, 
                        categoria:categoria,
                        data_final:periodo.data_final,
                        data_inicial:periodo.data_inicial,
                        filtro:filtro
                    }
                }).then(({data}) => {
                    this.tickets = data.map(item => {
                        item.solicitantes = item.solicitantes
                            ? JSON.parse(item.solicitantes)
                            : [];
                        return item;
                    });
                    this.mostrar_tabela = true;
                    this.carregar_tabela = false;
                }).catch(err => {
                    console.warn(err);
                    this.mostrar_tabela = false;
                });
            },
            loadStats(dados) {
                if (this.loading) {
                    this.dados_grafico = {};
                    return
                }
                const labelTop = {
                    normal: {
                        position: 'top',
                        show: true,
                        formatter: (param) => param.value>0?param.value:'',
                    }
                }
                
                this.dados_grafico = {
                    legend: {},
                    tooltip: {
                        formatter: (param) => param.seriesName + "<br />" + param.marker + ' ' + param.name + ': ' + Math.abs(param.value)
                    },
                    xAxis: {
                        data: this.legenda,
                        silent: false,
                        axisLine: {onZero: true},
                        splitArea: {show: false},
                        splitLine: {show: false}
                    },
                    yAxis: {},
                    grid: {
                        left: 50,
                        right: 50,
                    },
                    label: {
                        position: 'top',
                        show: true,
                        formatter: (param) => param.value || '',
                    },
                    series: dados
                }
            },
            caregarLegenda(size) {
                let legenda = []
                if (this.formato === "semanal") {
                    legenda = ["Esta sem.", "1 sem. atrás"]
                    for (let i = 2; i < size; i++) {
                        legenda[i] = `${i} sem. atrás`
                    }
                } else {
                    for (let i = 0; i < size; i++) {
                        legenda[i] = moment().subtract(i, 'months').format("MMMM/YY")
                    }
                }
                return legenda.reverse()
            },
            getTotalPGD(item) {
                return item.aprovados - item.fechados - item.resolvidos;
            },
            getTotalQuarentena(item) {
                return item.abertos - item.aprovados;
            },
            getChartData(dados) {
                const initial = dados.pop()
                dados = dados.reverse()
                const chart = []
                chart.push({
                    name: "Abertos",
                    type: 'bar',
                    color: "#f44336",
                    data: dados.map(item => item.abertos),
                });
                if (this.tipo !== 'bug') {
                    chart.push({
                        name: "Aprovados",
                        type: 'bar',
                        color: "#ffc107",
                        data: dados.map(item => item.aprovados),
                    });
                }
                chart.push({
                    name: "Resolvidos",
                    type: 'bar',
                    color: "#03a9f4",
                    data: dados.map(item => item.resolvidos),
                });
                chart.push({
                    name: "Fechados",
                    type: 'bar',
                    color: "#26a69a",
                    data: dados.map(item => item.fechados),
                });
                if (this.mostrar_totalizadores) {
                    chart.push({
                        name: "Total - PGD",
                        type: 'line',
                        color: "#d32f2f",
                        data: dados.reduce((accu, curr, idx) => {
                            accu[idx] = accu[accu.length - 1] + curr.aprovados - curr.fechados - curr.resolvidos;
                            return accu;
                        }, [this.getTotalPGD(initial)]),
                    });
                    if (this.tipo !== 'bug') {
                        chart.push({
                            name: "Total - Quarentena",
                            type: 'line',
                            color: "#ffd54f",
                            data: dados.reduce((accu, curr, idx) => {
                                accu[idx] = accu[accu.length - 1] + curr.abertos - curr.aprovados;
                                return accu;
                            }, [this.getTotalQuarentena(initial)]),
                        });
                    }
                }
                return chart;
            },

            async getModulos(){
                let modulos = await this.getChildren(1)
                this.modulos = _.orderBy(modulos, ['label'],['asc'])
            },

            async getChildren(id) {
                if (!id) return [];
                const {data: children} = await this.$axios.get(`tree/${id}/children`)
                return children.map(item => ({
                    value: item.id,
                    label: item.nome
                }))
            },

        },
        async created(){
            this.getModulos()
            await this.carregarDados()
        },
        mounted() {
            this.loadStats(this.dados)
        },
        watch: {
            dados() {
                this.loadStats(this.dados)
            },
            refresh(){
                if (this.refresh){
                    this.modulo = null
                    this.funcao = null
                    this.funcionalidade = null
                    this.analista = null
                    this.formato = 'semanal'
                    this.periodo = 6
                    this.mostrar_tabela = false
                    this.carregarDados()
                }
            },
            download(){
                this.csv=this.download
            },
            async modulo(){
                if(this.modulo){
                    let funcoes = await this.getChildren(this.modulo)
                    this.funcoes = _.orderBy(funcoes, ['label'],['asc'])
                    this.carregarDados({modulo:this.modulo})
                    this.mostrar_tabela = false
                } else {
                    this.carregarDados(false)
                    this.mostrar_tabela = false
                }
            },
            async funcao(){
                if (this.funcao){
                    let funcionalidades = await this.getChildren(this.funcao)
                    this.funcionalidades = _.orderBy(funcionalidades, ['label'],['asc'])
                    this.carregarDados({funcao:this.funcao})
                    this.mostrar_tabela = false
                } else {
                    this.carregarDados({modulo:this.modulo})
                    this.mostrar_tabela = false
                }
            },
            async funcionalidade(){
                if (this.funcionalidade) {
                    this.carregarDados({funcionalidade:this.funcionalidade})
                    this.mostrar_tabela = false
                } else {
                    this.carregarDados({funcao:this.funcao})
                    this.mostrar_tabela = false
                }
            },
            close(){
                if (this.close){
                    this.mostrar_tabela = false
                    this.mostrar_grafico = false
                } else {
                    this.mostrar_grafico = true
                }    
            },
            mostrar_tabela(){
                this.$emit('download',this.mostrar_tabela)
            }
        }
    }
</script>

<style scoped>
    .ivu-switch{
        margin: 7px 0 7px 7px;
    }
</style>